import { render, staticRenderFns } from "./active_sessions_table.vue?vue&type=template&id=40b324cc&scoped=true&"
import script from "./active_sessions_table.vue?vue&type=script&lang=ts&"
export * from "./active_sessions_table.vue?vue&type=script&lang=ts&"
import style0 from "./active_sessions_table.vue?vue&type=style&index=0&id=40b324cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b324cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VChip,VDataTable,VIcon})
